import { resolveReportThemeOverrides, convertThemeServiceResponseToThemeParameterOverrides, } from '@sas/nova-commons/design-tokens';
export async function fetchThemeParameters(url, themeName) {
    const headers = {
        Accept: 'application/vnd.sas.theme.report.complete+json',
    };
    const response = await fetch(`${url}/themes/themes/${themeName}`, {
        credentials: 'include',
        headers,
    });
    if (!response.ok) {
        throw new Error(`Failed to fetch report theme ${themeName}`);
    }
    const theme = await response.json();
    if (theme.type !== 'custom') {
        console.warn(`Expected theme ${themeName} to have type 'custom' but got '${theme.type}'`);
    }
    const overrides = convertThemeServiceResponseToThemeParameterOverrides(theme);
    return resolveReportThemeOverrides(overrides);
}
export async function fetchOfflineThemeParameters(packageUri, themeName) {
    const response = await fetch(`${packageUri}/css/theme-${themeName}.json`);
    if (!response.ok) {
        throw new Error(`Failed to fetch report theme ${themeName}`);
    }
    const theme = await response.json();
    if (theme.type !== 'custom') {
        console.warn(`Expected theme ${themeName} to have type 'custom' but got '${theme.type}'`);
    }
    const overrides = convertThemeServiceResponseToThemeParameterOverrides(theme);
    return resolveReportThemeOverrides(overrides);
}
